@let _contentComponent = contentComponent();
@let _contentTemplate  = contentTemplate();
@let _contentString    = contentString();

<div class="modal-window" [ngStyle]="cssStyle()" [ngClass]="cssClass()" [class.fullscreen]="options().fullscreen">
  @if (_contentComponent) {
    <ng-container *ngComponentOutlet="_contentComponent; inputs: data()"></ng-container>
  }
  @else if (_contentTemplate) {
    <ng-container *ngTemplateOutlet="_contentTemplate; context: data()"></ng-container>
  }
  @else if (_contentString) {
    {{_contentString}}
  }

  @if (options().showClose) {
    <button class="modal-close icon-button" (click)="close()">
      <app-svg-icon [name]="'close'" />
    </button>
  }
</div>
